import React, { FunctionComponent, useCallback } from 'react';
import { Box, Grid } from '@material-ui/core';
import { IExteriorColour } from '../../../../../common/model/IColours';
import colorPickerStyles from './colorPickerStyles';
import ColorButton from './colorButton/ColorButton';
import carDataExtractor from '../../service/carDataExtractor';
import { ImageType } from '../../enum/ImageType';
export interface IColorPickerProps {
  colorsArray: IExteriorColour[];
  onClick: (id: string) => void;
  activeColors: string[];
}

const ColorPicker: FunctionComponent<IColorPickerProps> = ({ colorsArray, onClick, activeColors }) => {
  const styles = colorPickerStyles();

  const getIsActive = useCallback(
    (color: IExteriorColour, activeColors: string[]) => {
      return activeColors.includes(color.id);
    },
    [activeColors],
  );

  return (
    <Grid container={true} direction={'row'} className={styles.container}>
      <Grid container={true} data-test="color_picker:container">
        {colorsArray.map((color: IExteriorColour, index: number) => {
          const colorImageSource = carDataExtractor.getImageSourcesFromImageList(color.images, ImageType.MAIN)[0];

          return (
            <Box mx={1} mb={1} key={index}>
              <ColorButton
                hexColorCode={color.hexColourCode ?? null}
                colorImageSource={colorImageSource ?? null}
                id={color.id}
                onClick={onClick}
                isActive={getIsActive(color, activeColors)}
                isDisabled={color.enabled === false}
              />
            </Box>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default ColorPicker;
